import { compareStudentNumbers } from "./roster.js";
import type { DailyRecord, HomeworkRecord, Student } from "./types.js";

export interface StudentSummary {
  studentId: string;
  number: number;
  sourceClass?: string;
  name: string;
  missingMaterials: number;
  answers: number;
  missingHomework: number;
}

export function buildStudentSummaries(
  students: Student[],
  dailyRecords: DailyRecord[],
  homeworkRecords: HomeworkRecord[],
): StudentSummary[] {
  return students
    .filter((student) => student.active)
    .map((student) => ({
      studentId: student.id,
      number: student.number,
      ...(student.sourceClass ? { sourceClass: student.sourceClass } : {}),
      name: student.name,
      missingMaterials: dailyRecords.reduce(
        (total, record) => total + (record.students[student.id]?.missingMaterials ? 1 : 0),
        0,
      ),
      answers: dailyRecords.reduce((total, record) => total + (record.students[student.id]?.answers ?? 0), 0),
      missingHomework: homeworkRecords.reduce(
        (total, record) => total + (record.students[student.id]?.status === "missing" ? 1 : 0),
        0,
      ),
    }))
    .sort(compareStudentNumbers);
}

export function answerMedalRanks(totals: readonly { studentId: string; answers: number }[]): Map<string, number> {
  const sorted = totals.filter((item) => item.answers > 0).sort((a, b) => b.answers - a.answers);
  const ranks = new Map<string, number>();
  let rank = 0;
  sorted.forEach((item, index) => {
    // Ties share a place; the next distinct total skips all occupied places.
    if (index === 0 || item.answers !== sorted[index - 1]?.answers) rank = index + 1;
    if (rank <= 3) ranks.set(item.studentId, rank);
  });
  return ranks;
}
